import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.03 17.818a3 3 0 0 0 1.97 -2.818v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8c0 1.317 .85 2.436 2.03 2.84","key":"svg-0"}],["path",{"d":"M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0","key":"svg-1"}],["path",{"d":"M8 21a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2","key":"svg-2"}]]

const IconUserScreen = createReactComponent('outline', 'user-screen', 'UserScreen', __iconNode);

export default IconUserScreen;